module.exports = __webpack_public_path__ + "static/media/check-step.b50ddc59.svg";